<template>
	<v-container
		class="fill-height"
		fluid
	>

		<v-row
			align="center"
			justify="center"
		>
			<v-col
				cols="12"
				sm="8"
				md="4"
			>
				<v-card class="elevation-12">
					<v-toolbar
						color="primary"
						dark
						flat
					>
						<v-toolbar-title>Acceso</v-toolbar-title>
						<!--<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn
									:href="source"
									icon
									large
									target="_blank"
									v-on="on"
								>
									<v-icon>mdi-code-tags</v-icon>
								</v-btn>
							</template>
							<span>Source</span>
						</v-tooltip>
						<v-tooltip right>
							<template v-slot:activator="{ on }">
								<v-btn
									icon
									large
									href="https://codepen.io/johnjleider/pen/pMvGQO"
									target="_blank"
									v-on="on"
								>
									<v-icon>mdi-codepen</v-icon>
								</v-btn>
							</template>
							<span>Codepen</span>
						</v-tooltip>-->
					</v-toolbar>
					<v-card-text>
						<v-form>
							<v-text-field
								label="Restaurante"
								name="password"
								prepend-icon="restaurant"
								type="text"
								v-model="acceso.restaurante"
								@keypress.enter="acceder"
								hint="Nombre de acceso al restaurante. Normalmente es el nombre del restaurante."
							></v-text-field>
							<v-text-field
								label="Código de acceso"
								name="login"
								prepend-icon="vpn_key"
								type="text"
								hint="Código de acceso de seis dígitos."
								minlenght="6"
								maxlenght="6"
								v-model="acceso.código"
								@keypress.enter="acceder"
							></v-text-field>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							:loading="cargando"
							:disabled="desactivado"
							@click="acceder"
						>
							Desbloquear
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<!-- Error: -->
		<v-snackbar
      v-model="verErrorDeAcceso"
			color="error"
			:timeout="20000"
    >
      {{ errorDeAcceso }}
      <v-btn
        llcolor="error"
        text
        @click="verErrorDeAcceso = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>

	</v-container>
</template>

<script>
//import { ofuscarJSON } from '../../../cliente-comun/utilidades'
import { ofuscarJSON } from '../utilidades'

export default {
	name: 'App',
  data: () => ({
    acceso: {
			restaurante: '',
			código: '',
		},
		cargando: false,
		errorDeAcceso: '',
		verErrorDeAcceso: false,
	}),
	computed: {
		desactivado: function () {
			return !this.acceso.restaurante || !this.acceso.código || this.acceso.código.trim().length !== 6
		}
	},
	methods: {
		acceder: function(){
			if (this.desactivado) {
				return
			}

			this.cargando = true
			this.verErrorDeAcceso = false
			this.$root.axios.post('/acceso', this.acceso).then(rta => {
				this.cargando = false
				if (!this.$root.datos) {
					this.$root.datos = {id: '', nombre: '', acceso: {restaurante: '', código: ''}}
				}

				this.$root.datos.id = rta.data.restaurante.id
				this.$root.datos.nombre = rta.data.restaurante.nombre
				this.$root.datos.acceso.restaurante = this.acceso.restaurante
				this.$root.datos.acceso.código = this.acceso.código
				//localStorage.setItem('restaurantes.servicio', this.$root.ofuscarJSON(this.$root.datos))
				localStorage.setItem('restaurantes.servicio', ofuscarJSON(this.$root.datos))
			}).catch(err => {
				this.cargando = false
				this.errorDeAcceso = err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Ocurrió un error. [2345]'
				this.verErrorDeAcceso = true
			})
		}
	}
}
</script>